import React from "react";
import AvatarSetting from "./AvatarSetting";
import DisplayNameSetting from "./DisplayNameSetting";
import EmailSetting from "./EmailSetting";
import PasswordSetting from "./PasswordSetting";
import MarketingPreferencesCard from "./MarketingPreferencesCard";
import AccountDataCard from "./AccountDataCard";
import ResetTradeDataCard from "./ResetTradeDataCard";
import { accountSettingsCardStackClassName } from "./SettingCard";

interface GeneralSectionProps {
  avatarImage: string;
}

const GeneralSection: React.FC<GeneralSectionProps> = ({ avatarImage }) => {
  return (
    <div className={accountSettingsCardStackClassName} data-account-settings-card-stack="" data-account-settings-general="">
      <AvatarSetting avatarImage={avatarImage} />
      <DisplayNameSetting />
      <EmailSetting />
      <PasswordSetting />
      <MarketingPreferencesCard />
      <AccountDataCard />
      <ResetTradeDataCard />
    </div>
  );
};

export default GeneralSection;
